import {
	BaseError,
} from './BaseError';

export class PostAssociateOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
